import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 200
    },
    infoContainer: {
        flexDirection: "column"
    },
    closeButton: {
        ...webStyle({
            cursor: "pointer"
        })
    },
    footerActionsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    footerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    infoRow: {
        flexDirection: "row",
        alignItems: "center"
    },
    errorContainer: {
        alignItems: "center"
    },
    container: {
        maxWidth: "94%",
        width: 680
    },
    contentContainer: {
        maxHeight: 520
    },
    coverImage: {
        width: "100%",
        height: 220
    },
    companyLogo: {
        height: 36,
        width: 36
    }
});
export default stylesheet;
